import { keyframes } from "@styles";

export const fadeIn = keyframes({
  from: {
    opacity: 0,
  },
  to: {
    opacity: 1,
  },
});

export const fadeInFromTop = keyframes({
  from: {
    opacity: 0,
    transform: "translateY(-10px)",
  },
  to: {
    opacity: 1,
    transform: "translateX(0)",
  },
});

export const fadeInFromLeft = keyframes({
  from: {
    opacity: 0,
    transform: "translateX(-100px)",
  },
  to: {
    opacity: 1,
    transform: "translateX(0)",
  },
});

export const fadeInFromBottom = keyframes({
  from: {
    opacity: 0,
    transform: "translateY(100px)",
  },
  to: {
    opacity: 1,
    transform: "translateX(0)",
  },
});

export const slideUpAndFade = keyframes({
  from: {
    opacity: "0",
    transform: "translateY(2px)",
  },
  to: {
    opacity: "1",
    transform: "translateY(0)",
  },
});

export const slideRightAndFade = keyframes({
  from: {
    opacity: "0",
    transform: "translateX(-2px)",
  },
  to: {
    opacity: "1",
    transform: "translateX(0)",
  },
});

export const slideDownAndFade = keyframes({
  from: {
    opacity: "0",
    transform: "translateY(-2px)",
  },
  to: {
    opacity: "1",
    transform: "translateY(0)",
  },
});

export const slideLeftAndFade = keyframes({
  from: {
    opacity: "0",
    transform: "translateX(2px)",
  },
  to: {
    opacity: "1",
    transform: "translateX(0)",
  },
});
